import cn from "./cn";
import en from "./en";
import jp from "./jp";
import ko from "./ko";

import type { FoundationRecord } from "@/data/catalog";
import type { HomeLocale } from "@/content/home";
import type { DocsContent, FoundationCopy } from "./types";

export type { DocsContent } from "./types";

export const docsContents = {
  ko,
  en,
  jp,
  cn,
} as const satisfies Record<HomeLocale, DocsContent>;

export const designDocumentForLocale: Record<HomeLocale, string> = {
  ko: "/DESIGN.md",
  en: "/DESIGN.en.md",
  jp: "/DESIGN.jp.md",
  cn: "/DESIGN.cn.md",
};

export function localizedFoundation(
  record: FoundationRecord,
  locale: HomeLocale,
): FoundationRecord {
  // English reads the per-foundation copy authored in catalog.json verbatim.
  if (locale === "en") return record;
  const localeCopy: Readonly<Record<string, FoundationCopy>> | undefined =
    docsContents[locale].foundationCopy;
  const copy = localeCopy?.[record.slug];
  if (!copy) return record;
  return {
    ...record,
    description: copy.description,
    intent: copy.intent,
    rules: [...copy.rules],
    accessibility: [...copy.accessibility],
    values: record.values.map(([role, use, value], index) => [
      role,
      copy.uses[index] ?? use,
      value,
    ]),
  };
}
